import React from 'react'
import Arora from '../../static/images/team/arora.png'

const DirectorCard = () => (
  <div className='section director-card'>
    <div className='container'>
      <div className='row'>
        <div className='img col-lg-4'>
          <img src={Arora} className='rounded-circle img-fluid' />
        </div>
        <div className='col-lg-8 quote'>
          <i
            className='bi bi-quote'
            data-aos='fade-right'
            data-aos-delay='100'
          ></i>
          <p>
            Rean is on the path of becoming the leading Integrated Water
            Company. I personally ensure that triple bottom line ethos remain
            the core of our business.
          </p>
          <caption>- Hitesh Arora, CMD</caption>
        </div>
      </div>
    </div>
  </div>
)

export default DirectorCard
